"use strict";

const { lazyLoadVideos } = require("./lazyvideo");

/**
 * Object to hold constants for hero banner functionality
 * @type {Object}
 */
const heroBannerConstants = Object.freeze({
    CONTAINER_SELECTOR: ".hero-banner--video",
    PLAY_BUTTON_CLASS_NAME: "btn-play",
    PAUSE_BUTTON_CLASS_NAME: "btn-pause",
    HIDDEN_CLASS_NAME: "invisible",
});

/**
 * Method to handle functionality for video element buttons based on action provided
 * @param {HTMLElement} controlEl - control element
 * @returns {void}
 */
const handleControlAction = (controlEl) => {
    if (!controlEl) return;

    const { CONTAINER_SELECTOR, HIDDEN_CLASS_NAME, PLAY_BUTTON_CLASS_NAME, PAUSE_BUTTON_CLASS_NAME } =
        heroBannerConstants;
    const containerEl = controlEl.closest(`${CONTAINER_SELECTOR}`);

    if (!containerEl) return;

    const videoEl = containerEl.querySelector(":scope video");

    if (!videoEl) return;

    // pause button
    const playBtnEl = containerEl.querySelector(`:scope .${PLAY_BUTTON_CLASS_NAME}`);

    // play button
    if (controlEl.classList.contains(`${PLAY_BUTTON_CLASS_NAME}`)) {
        const pauseBtnEl = containerEl.querySelector(`:scope .${PAUSE_BUTTON_CLASS_NAME}`);

        if (!pauseBtnEl) return;

        videoEl.play();

        controlEl.classList.add(`${HIDDEN_CLASS_NAME}`);
        pauseBtnEl.classList.remove(`${HIDDEN_CLASS_NAME}`);
        return;
    }

    if (!playBtnEl) return;

    videoEl.pause();
    controlEl.classList.add(`${HIDDEN_CLASS_NAME}`);
    playBtnEl.classList.remove(`${HIDDEN_CLASS_NAME}`);
};

/**
 * Method to handle video button controls events
 * @returns {void}
 */
const handleControlsEvents = () => {
    const { CONTAINER_SELECTOR, PLAY_BUTTON_CLASS_NAME, PAUSE_BUTTON_CLASS_NAME } = heroBannerConstants;

    const playButtonCollection = document.querySelectorAll(`${CONTAINER_SELECTOR} .${PLAY_BUTTON_CLASS_NAME}`);
    const pauseButtonCollection = document.querySelectorAll(`${CONTAINER_SELECTOR} .${PAUSE_BUTTON_CLASS_NAME}`);

    if (!playButtonCollection.length || !pauseButtonCollection.length) return;

    playButtonCollection.forEach((playBtn) => {
        playBtn.addEventListener("click", event => {
            event.preventDefault();
            handleControlAction(playBtn);
        });
    });

    pauseButtonCollection.forEach((pauseBtn) => {
        pauseBtn.addEventListener("click", event => {
            event.preventDefault();
            handleControlAction(pauseBtn);
        });
    });
};

/**
 * Method to initialize video banner functionality
 * @return {void}
 */
const initVideoBanner = () => {
    const { CONTAINER_SELECTOR } = heroBannerConstants;
    const videoBannerContainer = document.querySelector(`${CONTAINER_SELECTOR}`);

    if (!videoBannerContainer) return;
    lazyLoadVideos();
    handleControlsEvents();
};

/**
 * Binds events for the hero banner video configuration element
 * @returns {void}
 */
const bindEvents = () => {
    initVideoBanner();
};

module.exports = {
    bindEvents
};
